module.exports = __webpack_public_path__ + "static/media/mira_search_t_header_old.07d9316a.png";